module.exports = __webpack_public_path__ + "img/eshop.26c78363.png";